export const isNumber = (value) => {
  return typeof value === 'number' && !isNaN(value)
}

export const isInt = (value) => {
  return isNumber(value) && value % 1 === 0
}

export const isDate = (value) => {
  return value instanceof Date
}

export const isBoolean = (value) => {
  return typeof value === 'boolean'
}

export const isObject = (value) => {
  return value === Object(value)
}

export const isDefined = (value) => {
  return value !== null && value !== undefined
}

export const isString = (value) => {
  return typeof value === 'string'
}

export const isArray = (value) => {
  return {}.toString.call(value) === '[object Array]'
}

export const isEmail = (value, strict) => {
  if (!isDefined(value)) {
    return false
  }

  if (!isString(value)) {
    return false
  }

  const large_pattern =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
  const strict_pattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  const pattern = strict == true ? strict_pattern : large_pattern
  if (!pattern.test(value)) {
    return false
  }
  return true
}

export const isNotEmpty = (value) => {
  if (value !== '' && value !== null && typeof value !== 'undefined') {
    return true
  }
  return false
}

export const isEmpty = (value) => {
  let attr

  // Null and undefined are empty
  if (!isDefined(value)) {
    return true
  }

  // Whitespace only strings are empty
  if (isString(value)) {
    return /^\s*$/.test(value)
  }

  // For arrays we use the length property
  if (isArray(value)) {
    return value.length === 0
  }

  // Dates have no attributes but aren't empty
  if (isDate(value)) {
    return false
  }

  // If we find at least one property we consider it non empty
  if (isObject(value)) {
    for (attr in value) {
      return false
    }
    return true
  }

  return false
}

export const checkNested = (obj, level, ...rest) => {
  if (obj === undefined || obj === null) {
    return false
  }
  if (rest.length == 0 && obj.hasOwnProperty(level)) {
    return true
  }
  return checkNested(obj[level], ...rest)
}

export const objHas = (object, needle) => {
  let obj = object
  const needles = needle.split('.')
  const needles_full = []
  let needles_square

  for (var i = 0; i < needles.length; i++) {
    needles_square = needles[i].split('[')
    if (needles_square.length > 1) {
      for (var j = 0; j < needles_square.length; j++) {
        if (needles_square[j].length) {
          needles_full.push(needles_square[j])
        }
      }
    } else {
      needles_full.push(needles[i])
    }
  }

  for (var i = 0; i < needles_full.length; i++) {
    const res = needles_full[i].match(/^((\d+)|"(.+)"|'(.+)')\]$/)
    if (res != null) {
      for (var j = 0; j < res.length; j++) {
        if (res[j] != undefined) {
          needles_full[i] = res[j]
        }
      }
    }

    if (!isDefined(obj[needles_full[i]])) {
      return false
    }
    obj = obj[needles_full[i]]
  }
  return true
}

export const getNested = (obj, level, ...rest) => {
  if (obj === undefined || obj === null) {
    return false
  }
  if (rest.length == 0 && obj.hasOwnProperty(level)) {
    return obj[level]
  }
  return getNested(obj[level], ...rest)
}


export const isValidLink = (link) => {
  const urlReg =
    /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/
  if (!urlReg.test(link)) {
    return false
  }
  return true
}